export const EXPERIENCES = [
  {
    slug: "sea-safari",
    tag: "01",
    title: "Sea Safari & Wildlife Tour",
    short:
      "The thrill of a high-speed boat ride combined with wildlife encounters — seals, dolphins and seabirds of Clew Bay.",
    heroImage: "/images/exp-sea-safari-hero.jpg",
    cardImage: "/images/rib-clew-bay.jpg",
    bodyImage: "/images/rib-insula-sunny.webp",
    secondaryImage: "/images/lighthouse-visit.webp",
    details: [
      { label: "Age", value: "8+" },
      { label: "Duration", value: "1 Hour" },
      { label: "Max capability", value: "16" },
      { label: "Price", value: "\u20AC50 per person" },
      { label: "Available", value: "Year-round, weather dependent" },
    ],
    included: ["Life Jacket"],
    bring: ["Warm clothes", "Drinking water", "Sun protection"],
    paragraphs: [
      "Experience the thrill of the open sea with our exhilarating Sea Safari adventure or wildlife tour \u2014 what about a high-speed boat tour and private island picnic?",
      "Feel the wind in your hair and the salt spray on your skin as we set sail on our high-speed RIBs (Rigid Inflatable Boats). With two high-speed RIBs at our disposal, we offer the ultimate in speed, agility and manoeuvrability, ensuring your time with us is nothing short of exhilarating.",
      "As we navigate the pristine waters of Clew Bay, keep your eyes peeled for the incredible marine life that calls this vibrant ecosystem home \u2014 from playful dolphins and graceful seals to seabirds soaring overhead.",
      "And the excitement doesn't end there: our Sea Safari also offers breathtaking scenic exploration as we journey along the rugged coastline, past hidden coves, towering sea cliffs and ancient rock formations, with experienced guides sharing their knowledge and passion for this stunning region.",
      "So don your life jacket, hold on tight, and get ready to set sail on the adventure of a lifetime.",
    ],
  },
  {
    slug: "boat-trips",
    tag: "02",
    title: "High-Speed RIB Tours",
    short:
      "Three tours of Clew Bay \u2014 the Wildlife Tour, the High-Speed Sea Safari and the Ultimate Private Island Picnic.",
    heroImage: "/images/exp-rib-hero.jpg",
    cardImage: "/images/rib-ttop.webp",
    bodyImage: "/images/exp-rib-1.jpg",
    secondaryImage: "/images/rib-helm-view.webp",
    details: [
      { label: "Age", value: "8+" },
      { label: "Duration", value: "1.5 Hours" },
      { label: "Max capability", value: "16" },
      { label: "Price", value: "\u20AC50 per person" },
      { label: "Available", value: "Year-round, weather dependent" },
    ],
    included: ["Life Jacket"],
    bring: ["Warm clothes", "Drinking water"],
    paragraphs: [
      "You have three different boat tours to choose from: the Wildlife Tour, the High-Speed Sea Safari Tour and The Ultimate Private Island Picnic Tour.",
      "Join us on an exciting and captivating voyage through the emerald waters of Clew Bay, where every turn reveals a new and enchanting spectacle \u2014 from playful seals and, sometimes, dolphins frolicking in the waters of the bay.",
      "As we navigate the tranquil waters, our expert guides share their knowledge and passion for the region's rich biodiversity \u2014 the migratory patterns of seabirds, the feeding habits of seals and the intricate ecosystems that sustain life beneath the waves.",
      "With its stunning vistas, rugged coastline and teeming wildlife, Clew Bay is a photographer's dream. Whether you're an avid wildlife enthusiast, a nature lover, or simply seeking a moment of serenity, our wildlife tours promise an experience that will stay with you long after the journey ends.",
    ],
  },
  {
    slug: "kayaking-sup",
    tag: "03",
    title: "Kayaking, SUP & Beach Sauna",
    short:
      "Paddle the crystal-clear waters of Clew Bay, then warm up in our wood-fired beach sauna.",
    heroImage: "/images/sup-lone.jpg",
    cardImage: "/images/water-activities.webp",
    bodyImage: "/images/sup-group.jpg",
    secondaryImage: "/images/kayaking-yellow.webp",
    details: [
      { label: "Age", value: "8+ (Beach sauna 16+)" },
      { label: "Duration", value: "2 Hours" },
      { label: "Max capability", value: "25" },
      { label: "Price", value: "\u20AC50 per person" },
      { label: "Available", value: "Year-round, weather dependent" },
    ],
    provided: [
      "Wetsuit & life jacket",
      "All equipment required",
      "Guide & safety cover",
      "High-speed RIB transfer to the island",
    ],
    bring: [
      "Towel & swimwear",
      "Drinking water & sun protection",
      "Old runners or beach shoes",
      "Pack lunch if you like",
    ],
    paragraphs: [
      "Kayaking, stand-up paddle boarding followed by our new beach sauna. Be taken by high-speed RIB to the island, kitted out with all the equipment, and have an amazing experience.",
      "Clew Bay kayaking and stand-up paddle boarding are dynamic water sports that beckon adventurers of all levels to paddle through outstanding landscapes and scenery around all the small islands in Clew Bay.",
      "Whether you're dipping your toes into kayaking for the first time or you're a seasoned paddler seeking new horizons, this sport offers an exhilarating gateway to explore the wonders of nature and its waterways in the bay.",
      "Allow yourself to immerse in the beauty of the natural world while experiencing the thrill of the open water. We offer a chance to learn new skills and forge unforgettable memories with high-quality images captured by us and sent to you free of charge.",
      "Get ready to paddle your way to unforgettable adventures and create memories that will last a lifetime with your friends and family.",
    ],
  },
  {
    slug: "sauna-experience",
    tag: "04",
    title: "Beach Sauna & Seaweed Experience",
    short:
      "Sauna Insula \u2014 our wood-fired beach sauna and revitalising seaweed bath on the island shore.",
    heroImage: "/images/sauna-girl-hero.jpg",
    cardImage: "/images/sauna-girl-card.jpg",
    bodyImage: "/images/sauna-insula-group.jpg",
    secondaryImage: "/images/exp-sauna-hero.jpg",
    details: [
      { label: "Age", value: "12+" },
      { label: "Duration", value: "1 Hour" },
      { label: "Max capability", value: "6\u201315 guests" },
      { label: "Price", value: "\u20AC20 per person" },
      { label: "Available", value: "Year-round" },
    ],
    bring: [
      "Towel & swimwear",
      "Drinking water",
      "Beach shoes",
      "Your own preference of sauna scents & oils",
    ],
    paragraphs: [
      "Escape the hustle and bustle of daily life and immerse yourself in the tranquility and beauty of Collanmore Island in Clew Bay. Our unique experience combines the ancient tradition of sauna bathing with the invigorating benefits of cold sea water exposure, all set against the backdrop of breathtaking views.",
      "Solid log burning sauna: step into our authentic solid log burning sauna, where the scent of wood fills the air and the heat envelops you in a comforting embrace. As you relax and unwind, feel your stress melt away and your muscles release tension with each passing moment.",
      "Cold sea water exposure: after your sauna session, prepare for an exhilarating experience as you immerse yourself in the crisp, invigorating waters of the sea. The contrast between the intense heat of the sauna and the refreshing coolness of the sea water leaves you feeling energised, refreshed and alive.",
      "Private island retreat: located in the heart of Clew Bay, Collanmore Island offers a secluded sanctuary where you can reconnect with nature and find inner peace. And the journey itself is part of it \u2014 an exhilarating high-speed transfer across the bay sets the stage for the tranquility that awaits.",
    ],
  },
];

export const TOUR_CARDS = EXPERIENCES.map((e) => ({
  slug: e.slug,
  title: e.title,
  short: e.short,
  image: e.cardImage,
}));
